// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_RetraduzirResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/traducoes/retraduzir.
 * `linhas` is how many keys the retranslation covered — 1 for a single key,
 * the page's key count for a whole page.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_RetraduzirResponseDados {
ok: boolean
linhas: number
}

export type Traducoes_RetraduzirResponse = ApiResponse<Traducoes_RetraduzirResponseDados>;

registerResponseContract('Traducoes_RetraduzirResponse', {
  ok:     { type: 'boolean', required: true },
  linhas: { type: 'number',  required: true },
})
